import DocumentRepository from "../Repository/DocumentRepository";
import getDatabase from "./database";
import ChangeDocumentDescription from "../UseCase/ChangeDocumentDescription";

const changeDocumentDescription: ChangeDocumentDescription = new ChangeDocumentDescription(
    new DocumentRepository(getDatabase())
);

export default function getChangeDocumentDescription(): ChangeDocumentDescription {
    return changeDocumentDescription;
}